import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	descriptionHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	descriptionHeader: {
		id: 'software-releases-version-summary-description.description-header',
		defaultMessage: 'Description',
		description: 'Text for he header of the version description field',
	},
});
export default messages;
